/** $(document).ready(function() {
    // Function to hide sold-out products
    function hideSoldOutProducts() {
        if ($('input:checkbox').is(":checked")) {
            $('div.false').addClass("hide-soldout");
        } else {
            $('div.false').removeClass("hide-soldout");
        }
    }

    // Attach event to checkbox
    $(document).on('change', 'input:checkbox', function() {
        hideSoldOutProducts();
    });

    // Reapply the logic after products are loaded via AJAX
    $(document).on('click', '.view-more-button', function() {
        // Wait for the AJAX request to complete
        $(document).ajaxComplete(function() {
            hideSoldOutProducts();
        });
    });

    // Initial check to hide sold-out products on page load
    hideSoldOutProducts();
});
**/

$(document).ready(function() {
    // Function to hide/show sold-out products
    function toggleSoldOutProducts() {
        if ($('input:checkbox').is(":checked")) {
            $('div.false').css("display", "none");
        } else {
            $('div.false').css("display", "block");
        }
    }

    // Attach event to checkbox
    $(document).on('change', 'input:checkbox', function() {
        toggleSoldOutProducts();
    });

    // Reapply the logic after products are loaded via AJAX
    $(document).on('click', '.view-more-button', function() {
        $(document).ajaxComplete(function() {
            toggleSoldOutProducts();
        });
    });

    // Initial check to hide/show sold-out products on page load
    toggleSoldOutProducts();
});
